import React from "react";

const AlertMessage = ({ alertMessage }) => {
    return (
        <div className={alertMessage.type}>
            <i className={alertMessage.icon} style={{fontSize: "25px"}}/>
            <p style={{marginTop: "15px", marginLeft: "8px", maxWidth: "80%"}}>{alertMessage.message}</p>
        </div>
    );

};

export default AlertMessage;